import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pursueCertificateMessage: {
    id: 'advertisements.header.pursue-certificate',
    defaultMessage: 'Pursue a verified certificate',
    description: 'Text used as header for certificate advertisement',
  },
  closeAlt: {
    id: 'advertisements.close',
    defaultMessage: 'Close',
    description: 'Alternative text for close icon',
  },
  firstTimeLearnerDiscountHeader: {
    id: 'learning.generic.upgradeNotification.firstTimeLearnerDiscount',
    defaultMessage: '{percentage}% First-Time Learner Discount',
    description: 'Header for first time leaner discount',
  },
  accessExpirationHeader: {
    id: 'learning.generic.upgradeNotification.accessExpiration',
    defaultMessage: 'Upgrade your course today',
    description: 'Header for access expiration countdown',
  },
  accessExpirationUrgentHeader: {
    id: 'learning.generic.upgradeNotification.accessExpirationUrgent',
    defaultMessage: 'Course Access Expiration',
    description: 'Header for access expiration countdown banner',
  },
  accessExpirationPastHeader: {
    id: 'learning.generic.upgradeNotification.accessExpirationPast',
    defaultMessage: 'Course Access Expiration',
    description: 'Header for past expiration countdown banner',
  },
  pastExpirationCallToActionLabel: {
    id: 'learning.generic.upgradeNotification.past-expiration.call-to-action-button.label',
    defaultMessage: 'View course details',
    description: 'Button label to navigate to course details for expired upgrades',
  },
  discountCodeMessage: {
    id: 'learning.generic.upgradeNotification.code',
    defaultMessage: 'Use code {code} at checkout',
    description: 'Message that provides user with a code to use at checkout',
  },
});

export default messages;
